import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ce90584c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ce90584c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce90584c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce90584c')) {
      api.createRecord('ce90584c', component.options)
    } else {
      api.reload('ce90584c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ce90584c&scoped=true", function () {
      api.rerender('ce90584c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeedBack/index.vue"
export default component.exports